import axios from "axios"
import { BASE_URL } from "@/constants/util"

export const fetchSSBUCharacters = async () => {
  try {
    const response = await axios({
      method: "GET",
      url: `${BASE_URL}game-resources/super-smash-bros-ultimate/static-data/characters`,
    })
    return response.data
  } catch (error) {
    return Promise.reject(error)
  }
}



// WEBPACK FOOTER //
// ./src/store/game/ssbu/ssbu.apis.js